import { Skeleton } from "@shared/components";

import { METHOD_ACCORDION_SKELETON_KEYS } from "./method-accordion-skeleton.constants";

import styles from "./method-accordion-skeleton.module.css";

export const MethodAccordionSkeleton = () => (
  <ul className={styles.list}>
    {METHOD_ACCORDION_SKELETON_KEYS.map((key) => (
      <li key={key} className={styles.item}>
        <Skeleton
          className={styles.icon}
          height="1.25rem"
          width="1.25rem"
        />
        <Skeleton
          className={styles.title}
          height="1rem"
          width="7.5rem"
        />
        <Skeleton
          className={styles.count}
          height="0.875rem"
          width="5rem"
        />
        <Skeleton
          className={styles.chevron}
          height="0.875rem"
          width="0.875rem"
        />
      </li>
    ))}
  </ul>
);
